module.exports = __webpack_public_path__ + "img/Device-VisitorRegistration-Lit.a1f5bed7.png";